import { atom } from 'jotai';

import { quoteCloneAtom } from '../_graphql/mutationQuoteClone';
import { accountsForCloneQueryAtom } from '../_graphql/queryAccountsForClone';
import { quoteDetailQueryAtom } from '../_graphql/queryQuoteDetail';

// 🔘🔘🔘 PLAIN ATOMS
export const $cloneQuoteId = atom<string | null>(null);
export const $cloneDialogSearchTerm = atom('');
export const $cloneDialogSelectedAccountIds = atom<string[]>([]);

// 🟢🟢🟢 REMOTE DATA -> quote detail for clone dialog
export const $remoteCloneQuoteDetail = quoteDetailQueryAtom((get) => ({
  variables: { id: get($cloneQuoteId) ?? '' },
  skip: !get($cloneQuoteId),
}));

// 🟢🟢🟢 REMOTE DATA -> searchable accounts for step 1
export const $remoteCloneDialogAccounts = accountsForCloneQueryAtom((get) => ({
  variables: { searchTerm: get($cloneDialogSearchTerm) || undefined },
}));

// 🟢🟢🟢 REMOTE DATA -> selected accounts by ID for step 2 summary
export const $remoteCloneDialogSelectedAccounts = accountsForCloneQueryAtom(
  (get) => {
    const ids = get($cloneDialogSelectedAccountIds);
    return {
      variables: { ids },
      skip: ids.length === 0,
    };
  },
);

// 🟠🟠🟠 ACTION -> clone quote
export const $cloneQuote = quoteCloneAtom({});

// 🟠🟠🟠 ACTION -> reset dialog state
export const $resetCloneDialog = atom(null, (_get, set) => {
  set($cloneQuoteId, null);
  set($cloneDialogSearchTerm, '');
  set($cloneDialogSelectedAccountIds, []);
});
